class CartItemController {
    constructor($state, $timeout, config, trolleySource, analyticsService, trolleyService, cartItemMessageService, announcerService) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.config = config;
        this.trolleySource = trolleySource;
        this.analyticsService = analyticsService;
        this.trolleyService = trolleyService;
        this.cartItemMessageService = cartItemMessageService;
        this.announcerService = announcerService;
    }

    $onInit() {
        this.productUrl = this.trolleyItem.UrlOverride || this.$state.href('shop.productdetails', {
            productId: this.trolleyItem.Stockcode,
            productName: this.trolleyItem.UrlFriendlyName,
        });
    }

    onError(reason) {
        this.analyticsService.pushError(reason);

        this.error = reason;
    }

    onSuccess() {
        this.clearError();
    }

    clearError() {
        this.error = null;

        this.cartItemMessageService.clearErrors(this.trolleyItem.Stockcode);
    }

    remove() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
                product: this.trolleyItem,
            },
            type: this.analyticsService.mapperTypes.customEvent.trolley.cartRemove,
        });
        this.trolleyService.removeTrolleyItem(this.trolleyItem.Stockcode)
            .then(() => {
                this.cartItemMessageService.removeItemMessages(this.trolleyItem.Stockcode);
                this.announcerService.announce(`${this.trolleyItem.Name} removed from trolley`);
            });
    }

    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
                product: this.trolleyItem,
            },
            type: this.analyticsService.mapperTypes.customEvent.productClick,
        });
    }
}

const cartItemComponentDefinition = {
    bindings: {
        trolleyItem: '<',
        classModifier: '@?',
    },
    controller: ['$state', '$timeout', 'config', 'TrolleySource', 'AnalyticsService', 'TrolleyService', 'CartItemMessageService', 'AnnouncerService', CartItemController],
    template: require('./cart-item.component.html').trim(),
};

module.exports = {
    CartItemController,
    cartItemComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-item.component.js